import React from 'react';
import { getValue } from './disputes-service';

type DisputeDetailsProps = {
    disputeDetails?: any;
};
export const DisputeDetails = ({ disputeDetails }: DisputeDetailsProps) => {    
        return (
            <div className="card mt-3 border-0">
                <div className="card-header border-0" style={{ backgroundColor: '#ebf2f9', padding: '15px' }}>
                    Dispute Details
                </div>
                <div className="card-body tableContentCardBody">
                    <div className="row">
                        {[
                            {
                                label: 'Result Date',
                                value: getValue(disputeDetails?.dateofDispute),
                            },
                            {
                                label: 'Dispute Comment',
                                value: getValue(disputeDetails?.disputeComment),
                            },
                            {
                                label: 'Resolution Comment',
                                value: getValue(disputeDetails?.resolutionComment),
                            },
                            {
                                label: 'Metric',
                                value: getValue(disputeDetails?.metric),
                            },
                            {
                                label: 'Proposed Value',
                                value: getValue(disputeDetails?.proposedValue),
                            },
                            {
                                label: 'Disputed Value',
                                value: getValue(disputeDetails?.disputedValue),
                            },
                            {
                                label: 'Dispute Created By',
                                value: getValue(disputeDetails?.disputeCreatedBy),
                            },
                            {
                                label: 'Dispute Type',
                                value: getValue(disputeDetails?.disputeType),
                            },
                            {
                                label: 'Resolved By',
                                value: getValue(disputeDetails?.disputeResolvedBy),
                            },
                            {
                                label: 'Resolution Reason',
                                value: getValue(disputeDetails?.resolutionReason),
                            },
                        ].map((item) => (
                            <div className="col-md-2 border-end" key={item.label}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <strong>{item.label}</strong>
                                    </div>
                                </div>
                                <div className="row mt-1 mb-2">
                                    <div className="col-md-12" style={{fontWeight:'normal'}}>{item.value}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
};
